export default "__VITE_ASSET__C2si91HI__"